import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Paragraph, Subheading } from '@treams/treams-ui';

import LearningEventsList from '../components/LearningEventsList';

export default function LearningMyEventsContainer() {
	const { t } = useTranslation();

	const { data, loading } = graphql.useLearningMyEventsQuery({
		variables: { first: 100 },
	});

	return (
		<>
			<Box mb={4}>
				<Subheading>{t('learning.events.myProposals.title')}</Subheading>
				<Paragraph>{t('learning.events.myProposals.description')}</Paragraph>
			</Box>

			<Flex flexWrap="wrap">
				<LearningEventsList
					events={data?.viewer.learningEventProposals as graphql.LearningEventConnection}
					loading={loading}
				/>
			</Flex>
		</>
	);
}
